"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.autoPeakPicking = void 0;
const ml_array_median_1 = __importDefault(require("ml-array-median"));
const nmr_processing_1 = require("nmr-processing");
function autoPeakPicking(spectrum, options) {
    const { minMaxRatio, maxNumberOfPeaks, noiseFactor, direction, windowFromIndex, windowToIndex, } = options;
    // we calculate the noise but this could be improved
    const noise = (0, ml_array_median_1.default)(spectrum.data.re.map((y) => Math.abs(y)));
    let { re, x } = spectrum.data;
    const { originFrequency: frequency } = spectrum.info;
    if (windowFromIndex !== undefined && windowToIndex !== undefined) {
        x = x.slice(windowFromIndex, windowToIndex);
        re = re.slice(windowFromIndex, windowToIndex);
    }
    let peaks = (0, nmr_processing_1.xyAutoPeaksPicking)({ x, y: re }, {
        frequency,
        direction,
        shape: { kind: 'lorentzian' },
        noiseLevel: noise * noiseFactor,
        minMaxRatio,
        realTopDetection: true,
        smoothY: false,
    });
    peaks.sort((a, b) => b.y - a.y);
    if (maxNumberOfPeaks < peaks.length)
        peaks = peaks.slice(0, maxNumberOfPeaks);
    return (0, nmr_processing_1.mapPeaks)(peaks, spectrum);
}
exports.autoPeakPicking = autoPeakPicking;
